import { render } from "./CardBlank.vue?vue&type=template&id=5b018d21&scoped=true"
const script = {}

import "./CardBlank.vue?vue&type=style&index=0&id=5b018d21&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b018d21"]])

export default __exports__